import React from 'react';
import { Check, X } from 'lucide-react';

interface TopicDeleteConfirmProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function TopicDeleteConfirm({ onConfirm, onCancel }: TopicDeleteConfirmProps) {
  return (
    <div className="absolute right-0 top-1/2 -translate-y-1/2 flex items-center gap-1 bg-white rounded-lg shadow-lg border border-gray-200 p-1">
      <button
        onClick={e => {
          e.stopPropagation();
          onConfirm();
        }}
        className="p-1 rounded hover:bg-gray-50 text-red-600"
        title="Confirm delete"
      >
        <Check size={16} />
      </button>
      <button
        onClick={e => {
          e.stopPropagation();
          onCancel();
        }}
        className="p-1 rounded hover:bg-gray-50 text-gray-500"
        title="Cancel"
      >
        <X size={16} />
      </button>
    </div>
  );
}
